module.exports = __webpack_public_path__ + "static/media/helsinki_2.8439be9c.jpg";